module.exports = __webpack_public_path__ + "img/com10.53979729.gif";